<template>
  <div class="productos">
    <v-container>
      <v-row>
        <v-col class="text-center">
          <template v-if="lang == 'en'">
            <span class="montserrat bold enfasis-size color-morado">Products</span>
          </template>
          <template v-else>
            <span class="montserrat bold enfasis-size color-morado">Productos</span>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="(destacado, d) in destacados"
          :key="'destacado-' + d"
        >
          <v-card color="#5C27B2" dark height="100%">
            <v-img
              class="white--text align-end"
              height="120px"
              :src="'https://nncms.actstudio.xyz' + destacado.imagenCover.path"
            >
            </v-img>

            <v-card-text class="text-center">
              <span
                class="d-block bold titulos-size uppercase my-3 color-blanco"
                >{{ destacado.name }}</span
              >
              <p class="texto-corrido-size my-6 color-blanco">
                {{ destacado.descripcionCorta }}
              </p>

              <template v-if="lang == 'en'">
                  <v-btn
                  :to="'/servicios/' + destacado.url"
                  class="my-6"
                  outlined
                  width="210"
                  height="35"
                >
                  See more
                </v-btn>
              </template>
              <template v-else>
                <v-btn
                  :to="'/servicios/' + destacado.url"
                  class="my-6"
                  outlined
                  width="210"
                  height="35"
                >
                  Ver más
                </v-btn>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      destacados: [],
    };
  },
  mounted: function () {
    if(this.lang == 'en'){
      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              activo: true,
            },
            populate: 1, // resolve linked collection items
            lang: 'en' // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.destacados = res.entries));
    }else{
      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              destacado: true,
              activo: true,
            },
            populate: 1, // resolve linked collection items
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.destacados = res.entries));
    }
  },
  computed: {
    lang: function () {
      return this.$i18n.locale
    }
  },
  watch:{
    lang: function () {
      if(this.lang == 'en'){
      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              activo: true,
            },
            populate: 1, // resolve linked collection items
            lang: 'en' // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.destacados = res.entries));
    }else{
      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              destacado: true,
              activo: true,
            },
            populate: 1, // resolve linked collection items
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.destacados = res.entries));
    }
    }
  }
};
</script>